var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDirection = function SvgDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0eb948",
    d: "M21.312 9.341 12.66.688a2.346 2.346 0 0 0-3.319 0L.688 9.341a2.346 2.346 0 0 0 0 3.319l8.652 8.652a2.346 2.346 0 0 0 3.319 0l8.652-8.652a2.346 2.346 0 0 0 0-3.319Z",
    "data-name": "Path 19008"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.065 8.857c-.054-.082.113.1-2.428-2.485a.691.691 0 0 0-.985.969l1.223 1.242H7.194a.691.691 0 0 0-.691.691v4.491a.691.691 0 0 0 1.382 0v-3.8h5.913l-1.223 1.243a.691.691 0 1 0 .985.969l2.267-2.3a.728.728 0 0 0 .235-1.018Z",
    "data-name": "Path 19009"
  })));
};
export default SvgDirection;